export default __webpack_public_path__ + "static/ERX_Logo Member TFA-de40d34df495edfbbbdeefbb02563ee9.png";